import React from 'react';
import * as PropTypes from 'prop-types';
/**/
import { useAuth0 } from '../../context/auth0';
import { EntryData } from './components/EntryData';
import { Login } from './components/Login';

const AuthenticationCheckout = (props) => {
  const { isAuthenticated } = useAuth0();
  if (isAuthenticated) {
    return <EntryData prefixesAreVisible={props.prefixesAreVisible}/>;
  } else {
    return <Login themeLink={props.themeLink} prefixesAreVisible={props.prefixesAreVisible} />;
  }
};

AuthenticationCheckout.propTypes = {
  themeLink: PropTypes.string.isRequired,
  prefixesAreVisible:PropTypes.string,
};

AuthenticationCheckout.sanitizeProps = (props) => ({
  ...props,
  themeLink: props.themeLink,
});

export default AuthenticationCheckout;
